import script from "./verify-email-notice.vue?vue&type=script&setup=true&lang=js"
export * from "./verify-email-notice.vue?vue&type=script&setup=true&lang=js"

import "./verify-email-notice.vue?vue&type=style&index=0&id=06e06ac4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06e06ac4"]])

export default __exports__